/* ============================================================================
 * bootstrap.js — Izabel de Paula
 * Constrói window.PRODUCTS, a fonte única que alimenta cart.js, product.js
 * e todos os cartões do site.
 * ----------------------------------------------------------------------------
 * O QUE MUDA face à versão anterior:
 *   1. Os dados do Shopify passam a MANDAR sobre os dados fixos do tema
 *      (imagem, galeria, preço, disponibilidade, título).
 *   2. A curadoria editorial passa a vir de metafields (window.IZB_META),
 *      com assets/theme-meta.js apenas como rede de segurança.
 *   3. Produtos novos numa coleção "catalogo" entram no site sozinhos.
 *
 * O MARKUP E O CSS NÃO MUDAM. O formato de window.PRODUCTS é exatamente o mesmo.
 * ========================================================================== */
(function () {
  "use strict";

  /* ---------------------------------------------------------------- opções */

  // true  -> mantém a ordem atual (theme-meta.js primeiro, novos no fim)
  // false -> usa a ordem da coleção "catalogo" definida no admin
  var PRESERVE_LEGACY_ORDER = true;

  // Deriva o nome curto do título do Shopify quando não há metafield nem
  // theme-meta.js. Corta no primeiro "|" ou " - ".
  var DERIVE_SHORT_NAME = true;

  /* ----------------------------------------------------------------- dados */

  var LEGACY = window.THEME_META || [];   // assets/theme-meta.js (fallback)
  var LIVE   = window.IZB_LIVE || window.SHOPIFY_LIVE || {}; // Shopify (novo, com fallback ao antigo)
  var META   = window.IZB_META || {};     // metafields, via izb-catalog-live.liquid
  var ASSETS = (window.SHOP && window.SHOP.assets) || "";

  var legacyBy = {};
  LEGACY.forEach(function (m) { legacyBy[m.handle] = m; });

  /* ---------------------------------------------------------------- ordem */

  var handles = [];
  var liveHandles = Object.keys(LIVE);

  if (PRESERVE_LEGACY_ORDER) {
    LEGACY.forEach(function (m) {
      if (LIVE[m.handle] && handles.indexOf(m.handle) === -1) handles.push(m.handle);
    });
  }

  // Produtos que ainda não estão na lista.
  // Só entram automaticamente se existir mesmo a coleção "catalogo" — assim
  // merchandising e produtos soltos não aparecem no site sem querer.
  if (window.IZB_CATALOG_OK) {
    liveHandles.forEach(function (h) {
      if (handles.indexOf(h) === -1) handles.push(h);
    });
  }

  if (!PRESERVE_LEGACY_ORDER && window.IZB_CATALOG_OK) handles = liveHandles.slice();

  /* -------------------------------------------------------------- helpers */

  function pick() {
    for (var i = 0; i < arguments.length; i++) {
      var v = arguments[i];
      if (v !== null && v !== undefined && v !== "") return v;
    }
    return undefined;
  }

  function bool(a, b, c) {
    if (a === true || a === false) return a;
    if (b === true || b === false) return b;
    return !!c;
  }

  function shortTitle(t) {
    if (!t || !DERIVE_SHORT_NAME) return "";
    return String(t)
      .split("|")[0]
      .split(" - ")[0]
      .replace(/\uFE0F/g, "")  // remove o seletor de emoji (o seguidor do R registado)
      .trim();
  }

  // Mapeia o "Tipo de produto" do Shopify para o grupo usado pelos filtros
  // da secção #loja (data-cat / data-filter).
  var GROUPS = {
    "kit": "kit",
    "kits": "kit",
    "capsula": "capsula", "cápsula": "capsula",
    "capsulas": "capsula", "cápsulas": "capsula",
    "suplemento": "capsula", "detox": "capsula",
    "creme": "creme", "gel": "creme", "cosmetico": "creme", "cosmético": "creme"
  };

  function groupOf(m, g) {
    var explicit = pick(m.cat, g.cat);
    if (explicit) return explicit;
    return GROUPS[(m.type || "").toLowerCase()] || "creme";
  }

  /* ------------------------------------------------------------- construção */

  window.PRODUCTS = handles.map(function (h) {
    var l = LIVE[h] || {};
    var m = META[h] || {};
    var g = legacyBy[h] || {};

    var liveMedia   = (l.media && l.media.length) ? l.media : (l.img ? [l.img] : []);
    var liveThumbs  = (l.thumbs && l.thumbs.length === liveMedia.length) ? l.thumbs : liveMedia;
    var liveGallery = liveMedia.map(function (u, i) { return { full: u, thumb: liveThumbs[i] || u }; });

    var curatedImg = g.imgFile ? ASSETS + g.imgFile : "";
    var curatedGal = (g.galleryFiles || []).map(function (x) {
      return { full: ASSETS + x.full, thumb: ASSETS + x.thumb };
    });

    return {
      slug:   pick(m.slug, g.slug, h),
      handle: h,

      // ---- Shopify manda, curadoria é fallback -------------------------
      name:    pick(m.name, g.name, shortTitle(l.title)) || h,
      img:     l.img || (liveMedia.length ? liveMedia[0] : curatedImg),
      gallery: liveGallery.length ? liveGallery  : curatedGal,

      price:     (l.price != null) ? l.price : 0,
      compareAt: (l.compareAt != null) ? l.compareAt : null,
      variant:   l.variant || null,
      available: l.available !== false,
      productUrl: l.url || "/products/" + h,

      // ---- curadoria editorial: metafield > theme-meta.js --------------
      cat:      groupOf(m, g),
      catLabel: pick(m.catLabel, g.catLabel, ""),
      vol:      pick(m.vol, g.vol, ""),
      rating:   pick(m.rating, g.rating, ""),
      badges:   m.badges || g.badges || [],
      short:    pick(m.short, g.short, ""),
      blurb:    pick(m.blurb, g.blurb, ""),
      d2:       null,
      d3:       null,

      bestseller: bool(m.bestseller, g.bestseller, false),
      bsRank:     (m.bsRank != null) ? m.bsRank : (g.bsRank != null ? g.bsRank : 99),
      exp:        bool(m.exp, g.exp, false)
    };
  }).filter(function (p) { return p.variant; });

  /* ---------------------------------------------------------------- avisos */

  if (window.console) {
    var found = {};
    window.PRODUCTS.forEach(function (p) { found[p.handle] = 1; });

    var missing = LEGACY
      .filter(function (m) { return !found[m.handle]; })
      .map(function (m) { return m.handle; });

    if (missing.length) {
      console.warn("[IZB] handles em theme-meta.js que já não existem na loja:", missing);
    }

    var noCuration = window.PRODUCTS
      .filter(function (p) { return !p.catLabel || !p.blurb; })
      .map(function (p) { return p.handle; });

    if (noCuration.length) {
      console.warn("[IZB] produtos sem metafields de cartão preenchidos:", noCuration);
    }

    if (!window.IZB_CATALOG_OK) {
      console.warn("[IZB] coleção 'catalogo' não encontrada — produtos novos do Shopify não entram no site automaticamente.");
    }
  }
})();